export interface IDonorStatus {
    id: number,
    requiresFollowUp: boolean,
    isRuledOut: boolean,
    description: string,
    associatedDisposition: number
}